import CalendarIcon from '@assets/images/navigation_icons/calendar.svg'
import CrewIcon from '@assets/images/navigation_icons/crew.svg'
import DashboardIcon from '@assets/images/navigation_icons/dashboard.svg'
import ItineraryIcon from '@assets/images/navigation_icons/itinirary.svg'
import MediaGalleryIcon from '@assets/images/navigation_icons/media_gallery.svg'
import TripIcon from '@assets/images/navigation_icons/trip.svg'
import WeatherIcon from '@assets/images/navigation_icons/weather.svg'
import WidgetsIcon from '@assets/images/navigation_icons/widgets.svg'
import YachtInfoIcon from '@assets/images/navigation_icons/yacht_info.svg'
import { getPages, isPageDisabled } from '@config'
import { ROUTES } from '@constants/app_routes'

export interface MenuButton {
  icon: string
  title: string
  active: string
  to: string
  pageName: string
  disabled: boolean
}

export enum BUTTON_KEYS {
  DETAILS = 'details',
  MAP = 'map',
  INFO_CHANNEL = 'info_channel',
  INFO = 'home',
  GALLERY = 'gallery',
  CALENDAR = 'calendar',
  TRIP = 'trip',
  CREW = 'crew',
  WEATHER = 'weather'
}

export const links = [
  {
    icon: DashboardIcon,
    title: 'Home',
    active: '/home',
    to: ROUTES.INFO,
    pageName: 'info'
  },
  {
    icon: YachtInfoIcon,
    title: 'Yacht Information',
    active: ROUTES.YACHT_PAGE,
    to: ROUTES.YACHT_PAGE,
    pageName: 'yacht_page'
  },
  {
    icon: WeatherIcon,
    title: 'Weather',
    active: ROUTES.WEATHER,
    to: ROUTES.WEATHER,
    pageName: BUTTON_KEYS.WEATHER
  },
  {
    icon: ItineraryIcon,
    title: 'Map',
    active: ROUTES.MAP,
    to: ROUTES.MAP,
    pageName: BUTTON_KEYS.MAP
  },
  // { icon: CamIcon, title: 'Cam', active: '/#', to: ROUTES.GALLERY, pageName: 'cam' },
  {
    icon: MediaGalleryIcon,
    title: 'MediaItem Gallery',
    active: '/gallery',
    to: '/gallery',
    pageName: BUTTON_KEYS.GALLERY
  },
  {
    icon: CalendarIcon,
    title: 'Calendar',
    active: ROUTES.CALENDAR,
    to: ROUTES.CALENDAR,
    pageName: BUTTON_KEYS.CALENDAR
  },
  {
    icon: TripIcon,
    title: 'Trip',
    active: ROUTES.TRIP,
    to: ROUTES.TRIP,
    pageName: BUTTON_KEYS.TRIP
  },
  {
    icon: CrewIcon,
    title: 'Crew',
    active: ROUTES.CREW,
    to: ROUTES.CREW,
    pageName: BUTTON_KEYS.CREW
  },
  {
    icon: WidgetsIcon,
    title: 'Info Channel',
    active: '/info_channel',
    to: '/info_channel',
    pageName: BUTTON_KEYS.INFO_CHANNEL
  }
].map(stub => {
  return { ...stub, disabled: false } as MenuButton
})

interface MenuItem {
  key: string
  omit?: string
}

const allPossibleMenuItems: MenuItem[] = [
  { key: BUTTON_KEYS.DETAILS },
  { key: BUTTON_KEYS.MAP },
  { key: BUTTON_KEYS.INFO_CHANNEL },
  { key: BUTTON_KEYS.INFO, omit: 'info' },
  { key: BUTTON_KEYS.GALLERY },
  { key: BUTTON_KEYS.TRIP },
  { key: BUTTON_KEYS.CALENDAR },
  { key: BUTTON_KEYS.CREW },
  { key: BUTTON_KEYS.WEATHER }
]

export const getRoute = (key: string) => {
  switch (key) {
    case 'yacht_page':
      return ROUTES.YACHT_PAGE
    case 'details':
      return ROUTES.DETAILS
    case 'safety_plan':
      return ROUTES.SAFETY_PLAN
    case 'three_d':
      return ROUTES.THREE_D
    default:
      return ''
  }
}

export function getEnabledMenuPages () {
  const disabledItems = allPossibleMenuItems.filter(item => isPageDisabled(item.omit || item.key))

  return links.filter(link => {
    return !link.disabled && !disabledItems.some(item => link.active === '/' + item.key || link.active === '/home/' + item.key)
  })
}

export function getFirstEnabledPage () {
  const enabledPages = getEnabledMenuPages()
  if (enabledPages[0].pageName === 'yacht_page') {
    const pages = getPages()
    const yachtInformationPages = pages.filter(page => page.parent === BUTTON_KEYS.DETAILS && !page.disabled)[1]
    if (yachtInformationPages) {
      return getRoute(yachtInformationPages.page)
    }
  }

  return enabledPages[0].to
}

export function checkPageEnabled (key: string) {
  const pages = getPages()
  return pages.find(p => p.key === key)?.disabled
}
